export const environment = {
  production: true,
  envName: 'production',
  title: 'Production Environment Heading',
  webURL: 'https://sistema.lubrikuv.com/',
  apiURL: 'https://sistema.lubrikuv.com/backend/',
  kPagosURL: 'https://kpagos.kuvesoft.xyz/',
  habilitarSuscripciones: true,
  version: '6.2.0'
};
